// extracted by mini-css-extract-plugin
module.exports = {"sddMessagingWrapper":"style_sddMessagingWrapper__3mOoY","aloHistoryIcon":"style_aloHistoryIcon__3hSNj","ssdMessagingNoResults":"style_ssdMessagingNoResults__2ahEv"};